import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import EditSVG from "../../../_uLearn/assets/media/svg_uLearn/edit-round.svg";
import uploadImg from "../../../_uLearn/assets/media/Images/upload.png";
import { fileValidation } from "../../../Global/fileValidation";
import clsx from "clsx";
import { CustomSelectWhite } from "../../custom/Select/CustomSelectWhite";
import { HeaderWrapper } from "../../../_uLearn/layout/components/header/HeaderWrapper";
import Validations from "../../../utils/validations";
import { vendorString, String } from "../../../utils/string";
import APICallService from "../../../api/apiCallService";
import { VENDORS } from "../../../api/apiEndPoints";
import { CustomSelectTable2 } from "../../custom/Select/custom-select-table";
import { success } from "../../../Global/toast";
import { Auth, VendorToast } from "../../../utils/toast";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../Global/loader";
import { APIkey } from "../../../utils/constants";
import AutoComplete from "../../custom/autoComplete";
import { vendorJSON } from "../../../api/apiJSON/vendor";
import AWS from "aws-sdk";
import imageUpload from "../../../_uLearn/assets/media/preloader.gif";
import Resizer from "react-image-file-resizer";
import Method from "../../../utils/methods";
import Spinner from "react-bootstrap/Spinner";
import {
  Region,
  S3_BUCKET_NAME,
  accessKey,
  secretKey,
} from "../../../utils/constants";
import CardHeader from "react-bootstrap/esm/CardHeader";
const S3_BUCKET = S3_BUCKET_NAME;
const REGION = Region;
AWS.config.update({
  accessKeyId: accessKey,
  secretAccessKey: secretKey,
  region: REGION,
});
const s3 = new AWS.S3();
const EditVendor = () => {
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [ImageLoading, setImageLoading] = useState(false);
  const [bannerImageLoading, setbannerImageLoading] = useState(false);
  const [categoryList, setcategoryList] = useState([]);
  const [subCategotyList, setSubCategotyList] = useState([]);
  const [profileData, setProfileData] = useState<{
    businessName: string;
    VendorName: string;
    phone: string;
    phoneCountry: string;
    email: string;
    buildingNumber: string;
    address: string;
    Category: any;
    SubCategory: string;
    image: any;
    imageReader: any;
    bannerImage: any;
    bannerImageReader: any;
    lat: any;
    lng: any;
    thumbnail: any;
    bannerImageThumbnail: any;
  }>({
    businessName: "",
    VendorName: "",
    phone: "",
    phoneCountry: "+255",
    email: "",
    buildingNumber: "",
    address: "",
    Category: "",
    SubCategory: "",
    image: "",
    imageReader: {},
    bannerImage: "",
    bannerImageReader: {},
    lat: "1",
    lng: "1",
    thumbnail: "",
    bannerImageThumbnail: "",
  });
  const [profileValidation, setProfileValidation] = useState<{
    businessName: boolean;
    VendorName: boolean;
    email: boolean;
    phone: boolean;
    buildingNumber: boolean;
    address: boolean;
    Category: boolean;
    SubCategory: boolean;
    nationalIdNumber: boolean;
    phoneNumber: boolean;
    image: boolean;
    bannerImage: boolean;
  }>({
    businessName: false,
    VendorName: false,
    email: false,
    buildingNumber: false,
    address: false,
    Category: false,
    SubCategory: false,
    nationalIdNumber: false,
    phone: false,
    phoneNumber: false,
    image: false,
    bannerImage: false,
  });
  const businessNameRef: any = useRef(null);
  const VendorNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneNumberRef = useRef(null);
  const imageRef = useRef(null);
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      await fetchVendorDetails();
      await fetchCategoryDetails(state?.category?.reference);
      setFetchLoader(false);
    })();
  }, []);
  const fetchVendorDetails = async () => {
    const apiService = new APICallService(VENDORS.getVendorDetails, state._id);
    const response = await apiService.callAPI();
    if (response) {
      setProfileData({
        businessName: response?.businessName || "",
        VendorName: response?.name || "",
        phone: response?.phone || "",
        phoneCountry: response?.phoneCountry || "",
        email: response?.email || "",
        buildingNumber: response?.locality || "",
        address: response?.address || "",

        Category: response?.category?.reference
          ? {
              value: response?.category?.reference || "",
              name: response?.category?.name || "",
              label: response?.category?.name || "",
              _id: response?.category?.reference || "",
              subCategory: response?.subCategory || "",
            }
          : null,
        SubCategory: response?.subCategory?.map((item: any) => {
          return {
            name: item?.name,
            value: item?.reference,
            label: item?.name,
          };
        }),
        image: response?.image,
        imageReader: null,
        bannerImage: response?.bannerImage,
        bannerImageReader: null,
        lat: response?.lat,
        lng: response?.lng,
        thumbnail: response.thumbnail,
        bannerImageThumbnail: response.bannerThumbnail,
      });
    }
    // await fetchCategoryDetails(response.category.reference);
  };

  const fetchCategoryDetails = async (id: any) => {
    let params = {
      needCount: true,
    };
    const apiService = new APICallService(VENDORS.categotyList, params);
    const response = await apiService.callAPI();
    if (response) {
      let data: any = [...categoryList];
      await response.records?.map((val: any) => {
        data.push({
          value: val._id,
          name: val.name,
          label: val.name,
          _id: val._id,
          subCategory: val.subCategory,
        });
      });
      setcategoryList(data);
      if (id) {
        const filteredArray = data.filter((item: any) => item._id === id);
        const tempSubcategoty = filteredArray[0].subCategory.map(
          (item: any) => {
            return {
              name: item.name,
              value: item._id,
              label: item.name,
            };
          }
        );
        setSubCategotyList(tempSubcategoty);
      }
    }
  };

  const handleImageChange = async (event: any) => {
    const selectedFiles = event.target.files;
    let temp = { ...profileData };
    let tempValidation: any = { ...profileValidation };
    if (!selectedFiles) return;
    // else {
    //   if (fileValidation(selectedFiles?.[0])) {
    //     temp.image = URL.createObjectURL(selectedFiles?.[0]);
    //     temp.imageReader = selectedFiles?.[0];
    //     tempValidation.image = false;
    //   }
    // }
    // setProfileData(temp);
    // setProfileValidation(tempValidation);
    const file = selectedFiles[0];
    if (fileValidation(file)) {
      const fileName = Method.generateRandomFileName(file.name);
      // Function to upload a file to S3
      const uploadToS3 = (file: any, key: any) => {
        return new Promise((resolve, reject) => {
          const params = {
            Body: file,
            Bucket: S3_BUCKET,
            Key: key,
          };
          s3.upload(params, (err: any, data: any) => {
            if (err) {
              reject(err);
            } else {
              resolve(data.Location);
            }
          });
        });
      };
      setImageLoading(true);
      try {
        // Upload original image
        const originalImageUrl = await uploadToS3(
          file,
          `vendor/vendorsLogo/${fileName}`
        );
        // Resize image to create thumbnail
        Resizer.imageFileResizer(
          file,
          100, // maxWidth
          90, // maxHeight
          "JPEG", // format
          100, // quality
          0, // rotation
          async (thumbnail) => {
            const thumbnailFileName = Method.generateRandomFileName(file.name);
            const thumbnailUrl = await uploadToS3(
              thumbnail,
              `vendor/vendorLogoThumbnail/${thumbnailFileName}`
            );
            // Update state with image and thumbnail URLs
            // const temp = { ...studentData };
            // const tempValidation = { ...studentValidation };
            setProfileData((prev: any) => {
              const temp = { ...prev };
              temp.image = originalImageUrl;
              temp.thumbnail = thumbnailUrl;
              temp.imageReader = file;
              return temp;
            });
            tempValidation.image = false;
            // Assuming setState function to update state
            // setStudentData(temp);
            // setStudentValidation(tempValidation);
            // setProfileData(temp);
            setProfileValidation(tempValidation);
            setImageLoading(false);
          },
          "file" // output type
        );
      } catch (error) {
        console.error("Error uploading files:", error);
        setImageLoading(false);
      }
    }
  };

  const handleBannerImageChange = async (event: any) => {
    const selectedFiles = event.target.files;
    let temp = { ...profileData };
    let tempValidation: any = { ...profileValidation };
    if (!selectedFiles) return;
    // else {
    //   if (fileValidation(selectedFiles?.[0])) {
    //     temp.bannerImage = URL.createObjectURL(selectedFiles?.[0]);
    //     temp.bannerImageReader = selectedFiles?.[0];
    //     tempValidation.bannerImage = false;
    //   }
    // }
    // setProfileData(temp);
    // setProfileValidation(tempValidation);
    const file = selectedFiles[0];
    if (fileValidation(file)) {
      const fileName = Method.generateRandomFileName(file.name);
      // Function to upload a file to S3
      const uploadToS3 = (file: any, key: any) => {
        return new Promise((resolve, reject) => {
          const params = {
            Body: file,
            Bucket: S3_BUCKET,
            Key: key,
          };
          s3.upload(params, (err: any, data: any) => {
            if (err) {
              reject(err);
            } else {
              resolve(data.Location);
            }
          });
        });
      };
      setbannerImageLoading(true);
      try {
        // Upload original image
        const originalImageUrl = await uploadToS3(
          file,
          `vendor/vendorsBanner/${fileName}`
        );
        // Resize image to create thumbnail
        Resizer.imageFileResizer(
          file,
          100, // maxWidth
          90, // maxHeight
          "JPEG", // format
          100, // quality
          0, // rotation
          async (thumbnail) => {
            const thumbnailFileName = Method.generateRandomFileName(file.name);
            const thumbnailUrl = await uploadToS3(
              thumbnail,
              `vendor/vendorBannerThumbnail/${thumbnailFileName}`
            );
            // Update state with image and thumbnail URLs
            // const temp = { ...studentData };
            // const tempValidation = { ...studentValidation };
            setProfileData((prev: any) => {
              const temp = { ...prev };
              temp.bannerImage = originalImageUrl;
              temp.bannerImageThumbnail = thumbnailUrl;
              temp.imageReader = file;
              return temp;
            });
            tempValidation.bannerImage = false;
            // Assuming setState function to update state
            // setProfileData(temp);
            setProfileValidation(tempValidation);
            setbannerImageLoading(false);
          },
          "file" // output type
        );
      } catch (error) {
        console.error("Error uploading files:", error);
        setbannerImageLoading(false);
      }
    }
  };

  const handleBasicDetailsChange = (name: string, value: string) => {
    let temp: any = { ...profileData };
    let tempValidation: any = { ...profileValidation };
    temp[name] = value.trimStart();
    tempValidation[name] = false;
    if (!value.length) tempValidation[name] = true;
    setProfileData(temp);
    setProfileValidation(tempValidation);
  };
  const handleOnKeyPressDigits = (event: any) => {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  };

  const handleCategoryChange = (e: any) => {
    const temp: any = { ...profileData };
    let validateTemp: any = { ...profileValidation };
    temp.Category = e;
    temp.SubCategory = [];
    validateTemp.Category = false;
    setProfileData(temp);
    setProfileValidation(validateTemp);
    let subCategoryTemp = e.subCategory.map((val: any) => {
      return {
        id: val._id,
        name: val.name,
        value: val._id,
        label: val.name,
      };
    });
    setSubCategotyList(subCategoryTemp);
  };
  const handleSubCategoryChange = (e: any) => {
    const temp: any = { ...profileData };
    let validateTemp: any = { ...profileValidation };
    temp.SubCategory = e;
    if (!e.length) {
      validateTemp.SubCategory = true;
    } else {
      validateTemp.SubCategory = false;
    }
    setProfileData(temp);
    setProfileValidation(validateTemp);
  };
  const handleAddressChange = async (
    value: string,
    lat: string,
    lng: string
  ) => {
    let tempValidation: any = JSON.parse(
      JSON.stringify({ ...profileValidation })
    );
    let temp: any = { ...profileData };
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${APIkey}`;
    await fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          const results = data.results[0];
          let districtMatched = false;
          // Extract city and district from the address components
          for (const component of results.address_components) {
            if (component.types.includes("administrative_area_level_3")) {
              if (!districtMatched) {
                temp.districtName = component.long_name;
                tempValidation.district = false;
                districtMatched = true;
              }
            } else if (
              component.types.includes("administrative_area_level_2")
            ) {
              if (!districtMatched) {
                temp.districtName = component.long_name;
                tempValidation.district = false;
                districtMatched = true;
              }
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              if (!districtMatched) {
                temp.districtName = component.long_name;
                tempValidation.district = false;
                districtMatched = true;
              }
            }
            if (!districtMatched) {
              temp.districtName = "";
              tempValidation.district = true;
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    temp["address"] = value.trimStart();
    temp["lat"] = lat;
    temp["lng"] = lng;
    setProfileData(temp);
    if (!value.trimStart().length) {
      tempValidation.address = true;
    } else {
      tempValidation.address = false;
    }
    setProfileValidation(tempValidation);
  };
  const handleSubmit = async () => {
    let temp: any = { ...profileData };
    let validateTemp: any = { ...profileValidation };
    let focusRef: any = null;
    if (temp.businessName === "") {
      validateTemp.businessName = true;
      focusRef = focusRef || businessNameRef;
    }
    if (temp.VendorName === "") {
      validateTemp.VendorName = true;
      focusRef = focusRef || VendorNameRef;
    }
    if (temp.phone === "" || temp.phone.length < 9 || temp.phone.length > 12) {
      validateTemp.phone = true;
      focusRef = focusRef || phoneNumberRef;
    }
    if (temp.email === "" || !Validations.validateEmail(temp.email)) {
      validateTemp.email = true;
      focusRef = focusRef || emailRef;
    }
    if (temp.buildingNumber === "") {
      validateTemp.buildingNumber = true;
    }
    if (temp.address === "") {
      validateTemp.address = true;
    }
    if (!temp.image) {
      validateTemp.image = true;
      focusRef = focusRef || imageRef;
    }
    if (!temp.bannerImage) {
      validateTemp.bannerImage = true;
    }
    if (!temp.Category) {
      validateTemp.Category = true;
    }
    if (!temp.SubCategory.length) {
      validateTemp.SubCategory = true;
    }
    if (Object.values(validateTemp).every((val) => val === false)) {
      setLoading(true);
      let apiService = new APICallService(
        VENDORS.updateVendor,
        vendorJSON.editVendor(profileData),
        {
          id: state._id,
        }
      );
      let response = await apiService.callAPI();
      if (response) {
        success(VendorToast.updatevender);
        navigate("/vendors");
      }
      setLoading(false);
    } else {
      // Scroll to the first invalid input field
      if (focusRef) {
        focusRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center", // Adjust this as needed
        });
      }
    }
    setProfileValidation(validateTemp);
  };

  return (
    <>
      <div className="container">
        {/* <HeaderWrapper /> */}
        <Row className="align-items-center">
          <Col xs={12} className="mb-5">
            <h1 className="fs-22 fw-bolder">{vendorString.editVendor}</h1>
          </Col>
        </Row>
        {fetchLoader ? (
          <div className="d-flex flex-column align-items-center">
            <Loader loading={fetchLoader} />
          </div>
        ) : (
          <Row>
            <Col md={4} className="mb-lg-0 mb-8">
              <Card className="border bg-light mb-7 min-h-250px">
                <CardHeader className="align-items-center border-bottom-0">
                  <h5 className="fs-22 fw-bolder required">
                    {vendorString.ProfileImage}
                  </h5>
                </CardHeader>
                {ImageLoading ? (
                  <>
                    <div className="d-flex justify-content-center align-items-center h-160px">
                      <img className="mh w-50px" src={imageUpload} alt="" />
                    </div>
                  </>
                ) : (
                  <Card.Body className="pt-0">
                    <Row>
                      <Col xs={12} className="text-md-center">
                        {profileData.image ? (
                          <Col xs={12} className="text-md-center">
                            <div className="border border-r10px bg-white p-1">
                              <div className="image-input image-input-outline min-w-xl-260px min-h-xl-150px">
                                <div
                                  className="image-input-wrapper shadow-none bgi-contain w-100 h-100 bgi-position-center"
                                  style={{
                                    // backgroundImage: `url(${sellerData.image})`,
                                    backgroundRepeat: `no-repeat`,
                                  }}
                                >
                                  {profileData.image && (
                                    <img
                                      width={262}
                                      height={149}
                                      src={profileData.image}
                                      className="img-fluid mh-150px border-r10px object-fit-contain"
                                      alt=""
                                    />
                                  )}
                                </div>
                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px"
                                  data-kt-image-input-action="change"
                                  title=""
                                >
                                  <img
                                    src={EditSVG}
                                    alt=""
                                    height={33}
                                    width={33}
                                  />
                                  <input
                                    type="file"
                                    name="avatar"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(event) => {
                                      handleImageChange(event);
                                    }}
                                  />
                                  <input type="hidden" name="avatar_remove" />
                                </label>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          <Col xs={12} className="text-md-center">
                            <div
                              className={clsx(
                                "upload-btn-wrapper border rounded",
                                profileValidation.image ? "border-danger" : ""
                              )}
                            >
                              <div className="symbol symbol-md-235px">
                                <img
                                  ref={imageRef}
                                  src={uploadImg}
                                  className="img-fluid min-h-200px min-w-200px"
                                  alt=""
                                />
                              </div>
                              <input
                                className="w-100 h-100"
                                type="file"
                                name="myfile"
                                onChange={(event) => {
                                  handleImageChange(event);
                                }}
                              />
                            </div>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                )}
              </Card>
              {/* <Col xs={12} className="mb-7">
                <h1 className="fs-22 fw-bolder">{MyProfile.ProfileImage}</h1>
              </Col> */}
              <Card className="border bg-light min-h-250px">
                <CardHeader className="align-items-center border-bottom-0">
                  <h5 className="fs-22 fw-bolder required">
                    {vendorString.BannerImage}
                  </h5>
                </CardHeader>
                {bannerImageLoading ? (
                  <>
                    <div className="d-flex justify-content-center align-items-center h-160px">
                      <img className="mh w-50px" src={imageUpload} alt="" />
                    </div>
                  </>
                ) : (
                  <Card.Body className="pt-0">
                    <Row>
                      <Col xs={12} className="text-md-center">
                        {profileData.bannerImage ? (
                          <Col xs={12} className="text-md-center">
                            <div className="border border-r10px bg-white p-1">
                              <div className="image-input image-input-outline min-w-xl-260px min-h-xl-150px">
                                <div
                                  className="image-input-wrapper shadow-none bgi-contain w-100 h-100 bgi-position-center"
                                  style={{
                                    // backgroundImage: `url(${sellerData.image})`,
                                    backgroundRepeat: `no-repeat`,
                                  }}
                                >
                                  {profileData.bannerImage && (
                                    <img
                                      width={262}
                                      height={149}
                                      src={profileData.bannerImage}
                                      className="img-fluid mh-150px border-r10px object-fit-contain"
                                      alt=""
                                    />
                                  )}
                                </div>
                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px"
                                  data-kt-image-input-action="change"
                                  title=""
                                >
                                  <img
                                    src={EditSVG}
                                    alt=""
                                    height={33}
                                    width={33}
                                  />
                                  <input
                                    type="file"
                                    name="avatar"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(event) => {
                                      handleBannerImageChange(event);
                                    }}
                                  />
                                  <input type="hidden" name="avatar_remove" />
                                </label>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          <Col xs={12} className="text-md-center">
                            <div
                              className={clsx(
                                "upload-btn-wrapper border rounded",
                                profileValidation.bannerImage
                                  ? "border-danger"
                                  : ""
                              )}
                            >
                              <div className="symbol symbol-md-235px">
                                <img
                                  src={uploadImg}
                                  className="img-fluid min-h-200px min-w-200px"
                                  alt=""
                                />
                              </div>
                              <input
                                className="w-100 h-100"
                                type="file"
                                name="myfile"
                                onChange={(event) => {
                                  handleBannerImageChange(event);
                                }}
                              />
                            </div>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                )}
              </Card>
              {/* <Col xs={12} className="mt-3">
                <h1 className="fs-22 fw-bolder">{MyProfile.BannerImage}</h1>
              </Col> */}
            </Col>
            <Col md={8}>
              <Card className="bg-light pt-2 mb-9 border">
                <Card.Header className="border-bottom-0">
                  <Card.Title>
                    <h5 className="fs-20 fw-bolder">
                      {vendorString.BasicDetails}
                    </h5>
                  </Card.Title>
                </Card.Header>
                <Card.Body className="pt-0 pb-5">
                  <Row className="align-items-center">
                    <Col>
                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.BusinessName}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                profileValidation.businessName
                                  ? "border-danger"
                                  : ""
                              )}
                              type="text"
                              placeholder="Enter business name…"
                              value={profileData.businessName}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "businessName",
                                  event.target.value
                                );
                              }}
                              ref={businessNameRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.VendorName}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                profileValidation.VendorName
                                  ? "border-danger"
                                  : ""
                              )}
                              type="text"
                              placeholder="Enter vendor name…"
                              value={profileData.VendorName}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "VendorName",
                                  event.target.value
                                );
                              }}
                              ref={VendorNameRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <div className="mb-3">
                              <Form.Label className="fs-16 fw-500 required">
                                {vendorString.PhoneNumber}
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Text
                                  className={clsx(
                                    "bg-white border-right-0 pe-1",
                                    profileValidation.phone
                                      ? "border-danger"
                                      : ""
                                  )}
                                >
                                  {/* <img src={CountryLogo} alt="Image" /> */}
                                </InputGroup.Text>
                                <InputGroup.Text
                                  className={clsx(
                                    "bg-white border-right-0 border-left-0 fs-16 fw-600 text-black px-6 ps-1 pe-3",
                                    profileValidation.phone
                                      ? "border-danger"
                                      : ""
                                  )}
                                >
                                  + 255
                                </InputGroup.Text>
                                <Form.Control
                                  name="phoneNumber"
                                  placeholder="Type here…"
                                  value={profileData.phone}
                                  className={clsx(
                                    "form-control-custom border-active-none bg-white border-left-0 ps-0",
                                    profileValidation.phone
                                      ? "border-danger"
                                      : ""
                                  )}
                                  aria-label="Default"
                                  aria-describedby="inputGroup-sizing-default"
                                  onChange={(event: any) => {
                                    handleBasicDetailsChange(
                                      "phone",
                                      event.target.value
                                    );
                                  }}
                                  onKeyPress={handleOnKeyPressDigits}
                                  ref={phoneNumberRef}
                                />
                              </InputGroup>
                            </div>
                          </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.Email}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                profileValidation.email ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="Enter email…"
                              value={profileData.email}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "email",
                                  event.target.value
                                );
                              }}
                              ref={emailRef}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.BuildingNumber}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                profileValidation.buildingNumber
                                  ? "border-danger"
                                  : ""
                              )}
                              type="text"
                              value={profileData.buildingNumber}
                              placeholder="Enter building number…"
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "buildingNumber",
                                  event.target.value
                                );
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.Address}
                            </Form.Label>
                            {/* <Form.Control
                              className={clsx(
                                'form-control-custom bg-white',
                                profileValidation.address ? 'border-danger' : ''
                              )}
                              type="text"
                              placeholder="Enter address…"
                              value={profileData.address}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  'address',
                                  event.target.value
                                );
                              }}
                            /> */}
                            <AutoComplete
                              address={profileData.address}
                              handleAddressChange={handleAddressChange}
                              lat={profileData.lat}
                              lng={profileData.lng}
                              border={clsx(
                                profileValidation.address ? "#e55451" : ""
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Card className="bg-light pt-2 mb-9 border">
                <Card.Header className="border-bottom-0">
                  <Card.Title>
                    <h5 className="fs-20 fw-bolder">
                      {vendorString.SelectCategory}
                    </h5>
                  </Card.Title>
                </Card.Header>
                <Card.Body className="pt-0 pb-5">
                  <Row className="align-items-center">
                    <Col>
                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 text-dark required">
                              {vendorString.Category}
                            </Form.Label>
                            <CustomSelectWhite
                              border={
                                profileValidation.Category ? "#e55451" : ""
                              }
                              options={categoryList.map((item: any) => {
                                return {
                                  ...item,
                                  // label: item.name,
                                };
                              })}
                              value={profileData.Category}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ): any => handleCategoryChange(e)}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <div className="mb-3">
                              <Form.Label className="fs-16 fw-500 required">
                                {vendorString.SubCategory}
                              </Form.Label>
                              <CustomSelectTable2
                                border={
                                  profileValidation.SubCategory ? "#e55451" : ""
                                }
                                options={subCategotyList?.map((item: any) => {
                                  return {
                                    ...item,
                                    label: item.name,
                                  };
                                })}
                                value={profileData.SubCategory}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ): any => handleSubCategoryChange(e)}
                                backgroundColor={"#fff !important"}
                                multiValueBackground="#f9f9f9"
                                minHieight={60}
                                indicatorDisplay="none"
                                display="none"
                                isMulti={true}
                                menuIsOpen={false}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Row className="align-items-center g-3 d-flex justify-content-end">
              {!loading && (
                <Col xs="auto">
                  <Button
                    variant="danger"
                    size="lg"
                    className="btn-active-danger"
                    onClick={() => navigate("/vendors")}
                  >
                    Cancel
                  </Button>
                </Col>
              )}
              <Col xs="auto">
                <Button
                  size="lg"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={loading || ImageLoading || bannerImageLoading}
                >
                  {!loading ? (
                    <span className="indicator-label fs-16 fw-bold">
                      {vendorString.Submit}
                    </span>
                  ) : (
                    <span
                      className="indicator-progress fs-16 fw-bold"
                      style={{ display: "block" }}
                    >
                      {String.PleaseWait}
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </Button>
              </Col>
            </Row>
          </Row>
        )}
      </div>
    </>
  );
};
export default EditVendor;
